// import { Button, DatePicker, Form, Input, InputNumber, Col, Row } from "antd";
// import dayjs from "dayjs";
// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
// import { addUserSalary } from "../../../redux/rtk/features/salary/salarySlice";
// import { loadAllSalaryComponents } from "../../../redux/rtk/features/salaryComponent/salaryComponentSlice";

// const SalaryAddSinglePopup = ({ data, setLoading }) => {
//   const [form] = Form.useForm();
//   const [startDate, setSalaryStartDate] = useState(null);
//   const [endDate, setSalaryEndDate] = useState(null);
//   const [loader, setLoader] = useState(false);

//   const user_id = useParams("id");
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(loadAllSalaryComponents());
//   }, []);

//   // Fetch salary components from Redux store
//   const salaryComponentData = useSelector(
//     (state) => state.salaryComponents?.list
//   );
//   console.log("salaryComponentData", salaryComponentData);

//   const onFinish = async (values) => {
//     setLoader(true);
//     setLoading(true);

//     // Prepare salary components data with salaryComponentId as keys
//     const salaryComponents = {};
//     salaryComponentData.forEach((component) => {
//       const componentId = component.id;
//       const componentName = component.componentName;
//       let fieldValue = form.getFieldValue(`salaryComponents.${componentName}`);
//       salaryComponents[componentId] = fieldValue;
//     });

//     const infodata = {
//       userId: parseInt(user_id.id),
//       startDate: dayjs(startDate).format("YYYY-MM-DD"),
//       endDate: dayjs(endDate).format("YYYY-MM-DD"),
//       salaryComponents, // Use salaryComponentId as keys
//     };

//     try {
//       const resp = await dispatch(addUserSalary(infodata)).unwrap();
//       if (resp.message === "success") {
//         setLoader(false);
//         dispatch(loadSingleStaff(user_id.id));
//         setLoading(false);
//         form.resetFields();
//         toast.success("Salary details added/updated successfully");
//       } else {
//         throw new Error("Failed to add salary history");
//       }
//     } catch (error) {
//       setLoader(false);
//       // setLoading10.setLoading(false);
//       toast.error("Failed to add salary history");
//     }
//   };

//   const onFinishFailed = () => {
//     toast.warning("Failed at adding salary");
//     setLoader(false);
//     setLoading(false);
//   };

//   // Calculate totals for display (CTC and In-Hand Salary)
//   const calculateTotals = () => {
//     const salaryComponents = {};

//     salaryComponentData.forEach((component) => {
//       const componentName = component.componentName;
//       let fieldValue =
//         form.getFieldValue(`salaryComponents.${componentName}`) || 0;

//       if (component.calculationType === "% of Basic") {
//         const basicSalary = form.getFieldValue("salaryComponents.Basic") || 0;
//         fieldValue = (fieldValue * basicSalary) / 100;
//       }

//       salaryComponents[componentName] = fieldValue;

//       const amountFieldName = `${componentName}Amount`;
//       form.setFieldsValue({
//         [`salaryComponents.${amountFieldName}`]: fieldValue || 0,
//       });
//     });

//     const incomeComponents = salaryComponentData
//       ?.filter((component) => component.componentType === "Income")
//       .map((component) => salaryComponents[component.componentName] || 0);

//     const deductionComponents = salaryComponentData
//       ?.filter((component) => component.componentType === "Deduction")
//       .map((component) => salaryComponents[component.componentName] || 0);

//     const totalIncome = incomeComponents.reduce((acc, curr) => acc + curr, 0);
//     const totalDeductions = deductionComponents.reduce(
//       (acc, curr) => acc + curr,
//       0
//     );

//     form.setFieldsValue({
//       ctc: totalIncome,
//       inHandSalary: totalIncome - totalDeductions,
//     });
//   };

//   return (
//     <Form
//       form={form}
//       style={{ marginBottom: "10px" }}
//       name="basic"
//       labelCol={{ span: 6 }}
//       wrapperCol={{ span: 16 }}
//       onFinish={onFinish}
//       onFinishFailed={onFinishFailed}
//       autoComplete="off"
//       onValuesChange={calculateTotals}
//     >
//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item
//             style={{ marginBottom: "10px" }}
//             label="Start Date"
//             name="startDate"
//             rules={[
//               {
//                 required: true,
//                 message: "Please input your start date!",
//               },
//             ]}
//           >
//             <DatePicker
//               onChange={(date) => setSalaryStartDate(date)}
//               format="DD-MM-YYYY"
//               style={{ width: "100%" }}
//             />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item
//             style={{ marginBottom: "10px" }}
//             label="End Date"
//             name="endDate"
//           >
//             <DatePicker
//               onChange={(date) => setSalaryEndDate(date)}
//               format="DD-MM-YYYY"
//               style={{ width: "100%" }}
//             />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Row gutter={24}>
//         <Col span={12}>
//           <h3 className="text-center text-lg mt-3 mb-3">Income</h3>
//           {salaryComponentData
//             ?.filter((component) => component.componentType === "Income")
//             .map((component, index) => (
//               <Form.Item
//                 key={index}
//                 style={{ marginBottom: "10px" }}
//                 label={component.componentName}
//                 name={`salaryComponents.${component.componentName}`}
//               >
//                 <InputNumber
//                   min={0}
//                   step={0.01}
//                   style={{ width: "100%" }}
//                   placeholder={component.componentName}
//                   addonAfter={
//                     component.calculationType === "% of Basic"
//                       ? "% of Basic"
//                       : null
//                   }
//                 />
//               </Form.Item>
//             ))}
//         </Col>
//         <Col span={12}>
//           <h3 className="text-center text-lg mt-3 mb-3">Deduction</h3>
//           {salaryComponentData
//             ?.filter((component) => component.componentType === "Deduction")
//             .map((component, index) => (
//               <Form.Item
//                 key={index}
//                 style={{ marginBottom: "10px" }}
//                 label={component.componentName}
//                 name={`salaryComponents.${component.componentName}`}
//               >
//                 <InputNumber
//                   min={0}
//                   step={0.01}
//                   style={{ width: "100%" }}
//                   placeholder={component.componentName}
//                   addonAfter={
//                     component.calculationType === "% of Basic"
//                       ? "% of Basic"
//                       : null
//                   }
//                 />
//               </Form.Item>
//             ))}
//         </Col>
//       </Row>

//       <hr />
//       <Row gutter={24}>
//         <Col span={12}>
//           {salaryComponentData
//             ?.filter((component) => component.componentType === "Income")
//             .map((component, index) => {
//               if (component.calculationType === "% of Basic") {
//                 return (
//                   <Form.Item
//                     key={index}
//                     style={{ marginBottom: "10px" }}
//                     label={`${component.componentName} Amount`}
//                     name={`salaryComponents.${component.componentName}Amount`}
//                     initialValue={0}
//                   >
//                     <InputNumber disabled style={{ width: "100%" }} />
//                   </Form.Item>
//                 );
//               }
//               return null;
//             })}
//         </Col>
//         <Col span={12}>
//           {salaryComponentData
//             ?.filter((component) => component.componentType === "Deduction")
//             .map((component, index) => {
//               if (component.calculationType === "% of Basic") {
//                 return (
//                   <Form.Item
//                     key={index}
//                     style={{ marginBottom: "10px" }}
//                     label={`${component.componentName} Amount`}
//                     name={`salaryComponents.${component.componentName}Amount`}
//                     initialValue={0}
//                   >
//                     <InputNumber disabled style={{ width: "100%" }} />
//                   </Form.Item>
//                 );
//               }
//               return null;
//             })}
//         </Col>
//       </Row>

//       <Row gutter={24}>
//         <Col span={12}>
//           <Form.Item style={{ marginBottom: "10px" }} label="CTC" name="ctc">
//             <InputNumber readOnly style={{ width: "100%" }} />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item
//             style={{ marginBottom: "10px" }}
//             label="In Hand Salary"
//             name="inHandSalary"
//           >
//             <InputNumber readOnly style={{ width: "100%" }} />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Form.Item
//         style={{ marginBottom: "10px" }}
//         label="Comment"
//         name="salaryComment"
//       >
//         <Input placeholder="Comment" />
//       </Form.Item>

//       <Form.Item
//         style={{ marginBottom: "20px" }}
//         wrapperCol={{ offset: 6, span: 12 }}
//       >
//         <Button
//           type="primary"
//           size="small"
//           htmlType="submit"
//           block
//           loading={loader}
//         >
//           Add Now
//         </Button>
//       </Form.Item>
//     </Form>
//   );
// };

// export default SalaryAddSinglePopup;


import { Button, DatePicker, Form, Input, InputNumber, Col, Row, Modal } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import { addUserSalary } from "../../../redux/rtk/features/salary/salarySlice";
import { loadAllSalaryComponents } from "../../../redux/rtk/features/salaryComponent/salaryComponentSlice";

const SalaryAddSinglePopup = ({ data }) => {
  const [form] = Form.useForm();
  const [startDate, setSalaryStartDate] = useState(null);
  const [endDate, setSalaryEndDate] = useState(null);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const user_id = useParams("id");
  const dispatch = useDispatch();

  useEffect(() => {
    if (isModalOpen) {
      dispatch(loadAllSalaryComponents());
    }
  }, [isModalOpen, dispatch]);

  // Fetch salary components from Redux store
  const salaryComponentData = useSelector(
    (state) => state.salaryComponents?.list
  );
  console.log("salaryComponentData", salaryComponentData);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
    setLoading(false);
  };

  const onFinish = async (values) => {
    setLoader(true);
    setLoading(true);

    // Prepare salary components data with salaryComponentId as keys
    const salaryComponents = {};
    salaryComponentData.forEach((component) => {
      const componentId = component.id;
      const componentName = component.componentName;
      let fieldValue = form.getFieldValue(`salaryComponents.${componentName}`);
      salaryComponents[componentId] = fieldValue;
    });

    const infodata = {
      userId: parseInt(user_id.id),
      startDate: dayjs(startDate).format("YYYY-MM-DD"),
      endDate: dayjs(endDate).format("YYYY-MM-DD"),
      salaryComponents, // Use salaryComponentId as keys
    };

    try {
      const resp = await dispatch(addUserSalary(infodata)).unwrap();
      if (resp.message === "success") {
        setLoader(false);
        dispatch(loadSingleStaff(user_id.id));
        setLoading(false);
        form.resetFields();
        setIsModalOpen(false); // Close modal on success
        toast.success("Salary details added/updated successfully");
      } else {
        throw new Error("Failed to add salary history");
      }
    } catch (error) {
      setLoader(false);
      setLoading(false);
      toast.error("Failed to add salary history");
    }
  };

  const onFinishFailed = () => {
    toast.warning("Failed at adding salary");
    setLoader(false);
    setLoading(false);
  };

  // Calculate totals for display (CTC and In-Hand Salary)
  const calculateTotals = () => {
    const salaryComponents = {};

    salaryComponentData.forEach((component) => {
      const componentName = component.componentName;
      let fieldValue =
        form.getFieldValue(`salaryComponents.${componentName}`) || 0;

      if (component.calculationType === "% of Basic") {
        const basicSalary = form.getFieldValue("salaryComponents.Basic") || 0;
        fieldValue = (fieldValue * basicSalary) / 100;
      }

      salaryComponents[componentName] = fieldValue;

      const amountFieldName = `${componentName}Amount`;
      form.setFieldsValue({
        [`salaryComponents.${amountFieldName}`]: fieldValue || 0,
      });
    });

    const incomeComponents = salaryComponentData
      ?.filter((component) => component.componentType === "Income")
      .map((component) => salaryComponents[component.componentName] || 0);

    const deductionComponents = salaryComponentData
      ?.filter((component) => component.componentType === "Deduction")
      .map((component) => salaryComponents[component.componentName] || 0);

    const totalIncome = incomeComponents.reduce((acc, curr) => acc + curr, 0);
    const totalDeductions = deductionComponents.reduce(
      (acc, curr) => acc + curr,
      0
    );

    form.setFieldsValue({
      ctc: totalIncome,
      inHandSalary: totalIncome - totalDeductions,
    });
  };

  const salaryForm = (
    <Form
      form={form}
      style={{ marginBottom: "10px" }}
      name="basic"
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 16 }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      onValuesChange={calculateTotals}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            style={{ marginBottom: "10px" }}
            label="Start Date"
            name="startDate"
            rules={[
              {
                required: true,
                message: "Please input your start date!",
              },
            ]}
          >
            <DatePicker
              onChange={(date) => setSalaryStartDate(date)}
              format="DD-MM-YYYY"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            style={{ marginBottom: "10px" }}
            label="End Date"
            name="endDate"
          >
            <DatePicker
              onChange={(date) => setSalaryEndDate(date)}
              format="DD-MM-YYYY"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <h3 className="text-center text-lg mt-3 mb-3">Income</h3>
          {salaryComponentData
            ?.filter((component) => component.componentType === "Income")
            .map((component, index) => (
              <Form.Item
                key={index}
                style={{ marginBottom: "10px" }}
                label={component.componentName}
                name={`salaryComponents.${component.componentName}`}
              >
                <InputNumber
                  min={0}
                  step={0.01}
                  style={{ width: "100%" }}
                  placeholder={component.componentName}
                  addonAfter={
                    component.calculationType === "% of Basic"
                      ? "% of Basic"
                      : null
                  }
                />
              </Form.Item>
            ))}
        </Col>
        <Col span={12}>
          <h3 className="text-center text-lg mt-3 mb-3">Deduction</h3>
          {salaryComponentData
            ?.filter((component) => component.componentType === "Deduction")
            .map((component, index) => (
              <Form.Item
                key={index}
                style={{ marginBottom: "10px" }}
                label={component.componentName}
                name={`salaryComponents.${component.componentName}`}
              >
                <InputNumber
                  min={0}
                  step={0.01}
                  style={{ width: "100%" }}
                  placeholder={component.componentName}
                  addonAfter={
                    component.calculationType === "% of Basic"
                      ? "% of Basic"
                      : null
                  }
                />
              </Form.Item>
            ))}
        </Col>
      </Row>

      <hr />
      <Row gutter={24}>
        <Col span={12}>
          {salaryComponentData
            ?.filter((component) => component.componentType === "Income")
            .map((component, index) => {
              if (component.calculationType === "% of Basic") {
                return (
                  <Form.Item
                    key={index}
                    style={{ marginBottom: "10px" }}
                    label={`${component.componentName} Amount`}
                    name={`salaryComponents.${component.componentName}Amount`}
                    initialValue={0}
                  >
                    <InputNumber disabled style={{ width: "100%" }} />
                  </Form.Item>
                );
              }
              return null;
            })}
        </Col>
        <Col span={12}>
          {salaryComponentData
            ?.filter((component) => component.componentType === "Deduction")
            .map((component, index) => {
              if (component.calculationType === "% of Basic") {
                return (
                  <Form.Item
                    key={index}
                    style={{ marginBottom: "10px" }}
                    label={`${component.componentName} Amount`}
                    name={`salaryComponents.${component.componentName}Amount`}
                    initialValue={0}
                  >
                    <InputNumber disabled style={{ width: "100%" }} />
                  </Form.Item>
                );
              }
              return null;
            })}
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item style={{ marginBottom: "10px" }} label="CTC" name="ctc">
            <InputNumber readOnly style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            style={{ marginBottom: "10px" }}
            label="In Hand Salary"
            name="inHandSalary"
          >
            <InputNumber readOnly style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
{/* 
      <Form.Item
        style={{ marginBottom: "10px" }}
        label="Comment"
        name="salaryComment"
      >
        <Input placeholder="Comment" />
      </Form.Item> */}

      <Form.Item
        style={{ marginBottom: "20px" }}
        wrapperCol={{ offset: 6, span: 12 }}
      >
        <Button
          type="primary"
          size="small"
          htmlType="submit"
          block
          loading={loader}
        >
          Add Now
        </Button>
      </Form.Item>
    </Form>
  );

  return (
    <>
      <Button 
        type="primary" 
        onClick={showModal}
      >
        Add New Salary
      </Button>
      
      <Modal
        title="Add New Salary Information"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={800}
        destroyOnClose={true}
        maskClosable={false}
      >
        {salaryForm}
      </Modal>
    </>
  );
};

export default SalaryAddSinglePopup;